import coreStore from '@/stores/core';
import API from '@/services';

const defaultABTestConfig = {
  'bot.intent_base': 'B_new_version',
  'bot.order_selection_ui': 'no_popup',
  'bot.overflowmanagement_test': 'OverflowManagement',
  'bot.service_csat': 'group_2_with_resolved_question',
};

export const getABTestConfig = async () => {
  const userStore = coreStore.safeGetStore('userStore');
  userStore.UPDATE_ABTEST_CONFIG(defaultABTestConfig);
  // 老的实验平台下线 还在使用的实验给一个默认值
  return defaultABTestConfig;
};

type NewABTestConfig = { [expName: string]: string };
export const getNewABTestConfig = async () => {
  const userStore = coreStore.safeGetStore('userStore');
  const newABTestingConfigs = userStore.newABTestingConfigs;
  if (newABTestingConfigs && Object.keys(newABTestingConfigs).length) {
    return newABTestingConfigs;
  }

  const preRes = await window.preRequest?.preGetExperiment;
  const experiments
    = preRes
    || (await (
      API as {
        getExperiment: () => Promise<{
          result: {
            [expName: string]: {
              layer_id: string;
              group_id: string;
              group_name: string;
            };
          };
        }>;
      }
    )
      .getExperiment()
      .catch(() => {}));

  // 重置，有结果也只使用一次
  window.preRequest && (window.preRequest.preGetExperiment = null);

  if (experiments?.result) {
    const userStore = coreStore.safeGetStore('userStore');
    const config: NewABTestConfig = Object.entries(experiments.result).reduce((prev, [expName, group]) => {
      prev[expName] = (group as any).group_name;
      return prev;
    }, {} as NewABTestConfig);
    userStore.UPDATE_NEW_ABTEST_CONFIG(config);
  }
};
